import ThumbSlider from "./thumbsliderswiper";

import {
  RELEASE_BOTTOM_NAVIGATION_READER,
  CLICKED_BOTTOM_NAVIGATION_READER,
  SWIPED_BOTTOM_NAVIGATION_READER,
} from "./../analytics/analyticsevents";

const noUiSlider = require("nouislider");

export default class SliderNavigation {
  _appState = null;
  pages = null;
  slider = null;
  thumbSlider = null;
  options = null;
  //thumbsNavigation

  constructor(appState, pages, options) {
    this._appState = appState;
    this.pages = pages;
    this.options = options;
    this.render();
    this._appState.on(
      "appState:currentpagechanged",
      this.setCurrentPage.bind(this)
    );
  }

  load() {
    if (this.thumbSlider) return;
    this.thumbSlider = new ThumbSlider(
      this._appState,
      this.pages,
      this.options.sizes
    );
    this.thumbSlider.load();
  }

  resize() {
    if (this.thumbSlider) this.thumbSlider.resize();
  }

  reload(pages) {
    this.pages = pages;
    this.thumbSlider.destroy();
    this.load();
    this.resize();
  }

  render() {
    $(".reader-navigation").removeClass("invisible");
    $(".page-num-min").text("1");
    $(".page-num-max").text(this.pages.length);
    let max = this.pages.length - 1;
    this.slider = $(".slider-navigation")[0];
    if (this.pages.length <= 1) {
      max = this.pages.length;
    }
    noUiSlider.create(
      this.slider,
      {
        start: 0,
        connect: [true, false],
        step: 1,
        range: {
          min: 0,
          max: max,
        },
      },
      true
    );

    this.setCurrentPage();

    this.slider.noUiSlider.on("start", () => {
      this.showThumbs();
    });

    this.slider.noUiSlider.on("slide", () => {
      this.moveToPage();
    });

    this.slider.noUiSlider.on("change", () => {
      this.sliderChanged();
    });
  }

  lastIndex = null;

  showThumbs() {
    if (!this.thumbSlider) this.load();
    this.thumbSlider.show();
    this.moveToPage();
    this.lastIndex = parseInt(this.slider.noUiSlider.get(), 10);
    this._appState.triggerEvent(CLICKED_BOTTOM_NAVIGATION_READER);
  }

  hideThumbs() {
    this.thumbSlider.hide();
  }

  moveToPage() {
    this.thumbSlider.moveToPage(parseInt(this.slider.noUiSlider.get(), 10));
  }

  sliderChanged() {
    this.moveToPage();
    this.hideThumbs();
    // We do the change here so that the topscroll happens before the page is changed
    //to avoid the page to flicker.
    if (this._appState.isDoublePage == false) {
      const scrollingContainer = document.querySelector("#reader");
      if (scrollingContainer) {
        scrollingContainer.scrollTop = 0;
      }
    }
    this._appState
      .changeCurrentPage(parseInt(this.slider.noUiSlider.get(), 10))
      .then(() => {})
      .catch(() => {});
    if (this.lastIndex !== parseInt(this.slider.noUiSlider.get(), 10)) {
      this._appState.triggerEvent(SWIPED_BOTTOM_NAVIGATION_READER);
    }
    this.lastIndex = parseInt(this.slider.noUiSlider.get(), 10);
    this._appState.triggerEvent(RELEASE_BOTTOM_NAVIGATION_READER);
  }

  setCurrentPage() {
    if (!this.slider.noUiSlider) return;
    const index = this._appState.currentPage;
    this.slider.noUiSlider.set(index);
  }

  destroy() {
    this._appState.off("appState:currentpagechanged", this.setCurrentPage);
    this.slider.noUiSlider.destroy();
    if (this.thumbSlider) this.thumbSlider.destroy();
  }
}



// WEBPACK FOOTER //
// ./src/common/components/sliderNavigation.js